import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const PublicWrapper = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const accesstoken = localStorage.getItem('accesstoken');
    const user = localStorage.getItem('user');
    if (accesstoken && user) {
      setIsAuthenticated(true);
    }
  }, []);

  return isAuthenticated ? (
    <Navigate to="/today" replace />
  ) : (
    children
  );
};

export default PublicWrapper;
